// extracted by mini-css-extract-plugin
export var bannerParent = "FullSectionCard-module--bannerParent--39bU8";
export var noBgColor = "FullSectionCard-module--noBgColor--19PhB";
export var bannerRight = "FullSectionCard-module--bannerRight--3uzPj";
export var bannerLeft = "FullSectionCard-module--bannerLeft--IkSez";
export var banner_imgShow = "FullSectionCard-module--banner_imgShow--27icQ";
export var noGradient = "FullSectionCard-module--no-gradient--21I3V";
export var contentimgParent = "FullSectionCard-module--contentimgParent--RWpw1";
export var contentImg = "FullSectionCard-module--contentImg--urhJN";
export var arrowLink = "FullSectionCard-module--arrowLink--1RUxO";
export var scndBgImg = "FullSectionCard-module--scndBgImg--9XU5v";
export var method_2 = "FullSectionCard-module--method_2--1jXT9";